import {Injectable} from '@angular/core';
import {BackendService} from '../../core/services/backend.service';


@Injectable()
export class Service extends BackendService {

}
